import { formatNumber } from "../../../helpers/Utils";
import "./dashboard-sections.css";
import useTranslator from "../../../hooks/useTranslator";

const PerfRow = ({ label, value, valueColor, isLoading = false }) => (
  <div className="bd-perf-row">
    <span className="bd-perf-label">{label}</span>
    <span className="bd-perf-value" style={valueColor ? { color: valueColor } : {}}>
      {isLoading
        ? <span className="db-shimmer" style={{ height: 16, width: 70, display: "inline-block" }} />
        : (value ?? "—")
      }
    </span>
  </div>
);

const YieldEfficiency = ({ data = [], isLoading = false }) => {
  const { _t } = useTranslator();
  const processing_performance = data?.processing_performance ?? [];

  return (
    <div className="bd-right-col cmn_card">
      <div className="bd-perf-header">{_t("processing_performance_db", "PROCESSING PERFORMANCE")}</div>
      <div className="bd-perf-body">
        <PerfRow label={_t("kg_prime_prcnt_db", "KG Prime %")}      value={`${processing_performance?.kg_prime_prcnt ?? "0"}%`}                              valueColor="#25aa91" isLoading={isLoading} />
        <PerfRow label={_t("kg_prime_db", "KG Prime")}              value={`${formatNumber(processing_performance?.kg_prime_total) ?? "0"} kg`}               isLoading={isLoading} />
        <PerfRow label={_t("kg_prime_rework_db", "KG Prime Rework")} value={`${formatNumber(processing_performance?.kg_prime_rework) ?? "0"} kg`}              isLoading={isLoading} />
        <PerfRow label={_t("kg_case_ratio_db", "KG/Case Ratio")}    value={processing_performance?.kg_per_case ?? "0"}                                         isLoading={isLoading} />
        <PerfRow label={_t("cases_per_cart_db", "Cases/Cart")}      value={processing_performance?.cases_per_cart ?? "0"}                                      isLoading={isLoading} />
        <PerfRow label={_t("total_peelers_db", "Total Peelers")}    value={formatNumber(processing_performance?.total_number_of_peelers) ?? "0"}               isLoading={isLoading} />
      </div>
    </div>
  );
};

export default YieldEfficiency;
